module.exports = __webpack_public_path__ + "static/media/Screenshot_(359).6f619283.png";